import React from 'react'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import PropTypes, { shape } from 'prop-types'
import { BreadcrumbLink, Container } from './styled'
import { useIsTenant } from '../../contexts/TenantContext'
import constants from '../../common/constants'

const BreadcrumbsComponent = (props) => {
  const { firstLevel, secondLevel, thirdLevel, margin } = props

  const hasLabel = (level) => level?.label && level.label !== ''

  const hasFirstLevelLabel = hasLabel(firstLevel)
  const hasSecondLevelLabel = hasLabel(secondLevel)
  const hasThirdLevelLabel = hasLabel(thirdLevel)

  const isSOD = useIsTenant(constants.tenant.SOD)
  const handleFirstLevelClick = (event) => {
    if (isSOD) {
      event.preventDefault()
    }
  }
  const getFirstLevelHoverColor = () => {
    if (isSOD) {
      return 'inherit'
    }
    return undefined
  }
  const getFirstLevelHoverCursor = () => {
    if (isSOD) {
      return 'inherit'
    }
    return undefined
  }

  return (
    <Container margin={margin}>
      <Breadcrumbs separator={<i className="zmdi zmdi-chevron-right" />} aria-label="breadcrumb">
        <BreadcrumbLink to="/">Home</BreadcrumbLink>
        {hasFirstLevelLabel && (
          <BreadcrumbLink
            to={`/category/${firstLevel.label}`}
            color={hasSecondLevelLabel ? 'inherit' : '#0071ce'}
            hoverColor={getFirstLevelHoverColor()}
            hoverCursor={getFirstLevelHoverCursor()}
            font={hasSecondLevelLabel ? 'Bogle' : 'Bogle Bold'}
            onClick={handleFirstLevelClick}
          >
            {firstLevel.label.replace(/_/g, ' ')}
          </BreadcrumbLink>
        )}
        {hasSecondLevelLabel && (
          <BreadcrumbLink
            to={`/category/${firstLevel.label}/${secondLevel.label}`}
            color={hasThirdLevelLabel ? 'inherit' : '#0071ce'}
            font={hasThirdLevelLabel ? 'Bogle' : 'Bogle Bold'}
          >
            {secondLevel.label.replace(/_/g, ' ')}
          </BreadcrumbLink>
        )}
        {hasThirdLevelLabel && (
          <BreadcrumbLink
            to={`/category/${firstLevel.label}/${secondLevel.label}/${thirdLevel.label}`}
            color="#0071ce"
            font="Bogle Bold"
          >
            {thirdLevel.label.replace(/_/g, ' ')}
          </BreadcrumbLink>
        )}
      </Breadcrumbs>
    </Container>
  )
}

export default BreadcrumbsComponent

BreadcrumbsComponent.defaultProps = {
  secondLevel: {},
  thirdLevel: {},
  margin: undefined,
}

BreadcrumbsComponent.propTypes = {
  firstLevel: shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
  secondLevel: shape({
    label: PropTypes.string,
  }),
  thirdLevel: shape({
    label: PropTypes.string,
  }),
  margin: PropTypes.string,
}
